import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Box, Tooltip, Typography } from '@material-ui/core'
import { OutlinedButton, Popup } from '../../elements'
import { forwardTo } from '../../utils/helper'
import { vppService } from '../../Services'
import StatusButton from '../StatusButton'
import {
  CREATE_NEW_EVENT,
  VIEW_VIRTUAL_POWER_PLANTS,
  PROGRAM_STATUS_ACTIVE_COLOR,
  PROGRAM_STATUS_INACTIVE_COLOR,
  SYSTEMS_ENROLLMENT,
  SYSTEMS_ADDITION,
  SYSTEMS_APPROVAL,
  PROGRAM_SETTINGS,
  ENROLL_NEW_SYSTEM,
} from './constants'
import { headerStyles } from './style'
import AppButton from '../AppButton'
import { withStyles } from '@material-ui/core/styles'
import AutoEnrollment from './AutoEnrollment'

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    boxShadow: theme.shadows[1],
    fontSize: 14,
    marginTop: '-5px',
    maxWidth: 'none',
    wordBreak: 'break-all'
  },
}))(Tooltip)

const ProgramHeader = (props) => {
  const classes = headerStyles()
  let { programName, isActive, programObject } = props
  const [programId, setProgramId] = useState('')
  const [showPopup, setShowPopup] = useState(false)
  const [showAutoEnrollment, setShowAutoEnrollment] = useState(false)

  useEffect(() => {
    const id = _.get(props.match.params, 'programs_id', '')
    setProgramId(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params])

  const handleProgramDetails = () => props.history.push(`/program-details/${programId}`)

  const handleSystemsEnrollment = (page) => props.history.push(`/programs/${programId}/${page === 'SYSTEM_APPROVAL' ? 'systems-approval' : 'systems-addition'}`)

  const handleAutoEnrollment = () => { setShowAutoEnrollment(true) }

  const handleViewVPPs = () => {
    forwardTo(`/programs/${programId}/vpp`)
  }

  const handleCreateNewEvent = () => {
    if (props.vppCount) {
      forwardTo(`/programs/${programId}/create-new-event`)
    } else {
      setShowPopup(true)
    }
  }

  const renderPopupContent = () => {
    return (
      <Box className={classes.popWrapper}>
        <Typography className={classes.popText}>You need an VPP to create a event. Please create a new VPP.</Typography>
        <AppButton text='Ok' className={classes.ackButton} onClick={() => setShowPopup(false)} />
      </Box>
    )
  }

  return (
    <>
      {showAutoEnrollment && <AutoEnrollment showAutoEnrollment={showAutoEnrollment} setShowAutoEnrollment={setShowAutoEnrollment} programId={programId} />}
      <Box className={classes.programHeaderBar} display="flex" flexWrap="wrap">
        <Box className={classes.programDetailsDynamic}>
          <CustomTooltip disableFocusListener title={programName}>
            <Typography className={classes.programTitle}>
              {programName}
            </Typography>
          </CustomTooltip>
          {isActive ? (
            <StatusButton
              color={PROGRAM_STATUS_ACTIVE_COLOR}
              text="Active"
            ></StatusButton>
          ) : (
            <StatusButton
              color={PROGRAM_STATUS_INACTIVE_COLOR}
              text="InActive"
            ></StatusButton>
          )}
        </Box>
        <Box className={classes.programDetailsStatic}>
          <Box className={classes.staticMargin}>
            {props.isAdmin && programObject && programObject.feature_flags && programObject.feature_flags.system_enrollment_option === 'SYSTEM_APPROVAL' &&
              <OutlinedButton
                classes={classes.button}
                label={SYSTEMS_APPROVAL}
                onClick={() => handleSystemsEnrollment(programObject.feature_flags.system_enrollment_option)}
              ></OutlinedButton>
            }
            {props.isAdmin && programObject && programObject.feature_flags && programObject.feature_flags.system_enrollment_option === 'SYSTEM_ADDITION' &&
              <OutlinedButton
                classes={classes.button}
                label={SYSTEMS_ADDITION}
                onClick={() => handleSystemsEnrollment(programObject.feature_flags.system_enrollment_option)}
              ></OutlinedButton>
            }
          </Box>
          {!props.isViewOnly && props.isAdmin && programObject && programObject.feature_flags && programObject.feature_flags.system_enrollment_option === 'AUTO_ENROLLMENT' &&
            <Box className={classes.staticMargin}>
              <OutlinedButton
                classes={classes.button}
                label={ENROLL_NEW_SYSTEM}
                onClick={handleAutoEnrollment}
              />
            </Box>
          }
          <Box className={classes.staticMargin}>
            <OutlinedButton
              classes={classes.button}
              label={PROGRAM_SETTINGS}
              onClick={handleProgramDetails}
            />
          </Box>
          {/* <Box className={classes.staticMargin}>
          <OutlinedButton
            classes={classes.button}
            label={VIEW_VIRTUAL_POWER_PLANTS}
            onClick={handleViewVPPs}
          ></OutlinedButton>
        </Box> */}
          {!props.isViewOnly && isActive && <Box className={classes.staticMargin}>
            <OutlinedButton
              classes={classes.button}
              label={CREATE_NEW_EVENT}
              onClick={handleCreateNewEvent}
            ></OutlinedButton>
          </Box>}
        </Box>
        <Popup
          open={showPopup}
          handleClose={() => setShowPopup(false)}
          content={renderPopupContent()}
        />
      </Box>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { accountId, isAdmin, isViewOnly } = auth
  return { accountId, isAdmin, isViewOnly }
}

export default connect(mapStateToProps, {})(ProgramHeader)
